import { render, staticRenderFns } from "./FabricSimpleFrameControlsCard.vue?vue&type=template&id=c506357c&scoped=true"
import script from "./FabricSimpleFrameControlsCard.vue?vue&type=script&lang=js"
export * from "./FabricSimpleFrameControlsCard.vue?vue&type=script&lang=js"
import style0 from "./FabricSimpleFrameControlsCard.vue?vue&type=style&index=0&id=c506357c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c506357c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VColorPicker,VIcon,VMenu,VSlider,VSpacer})
